import React from 'react'
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/auth';

export default function VerifiedMember({ children }) {
  const user = useAuthStore((state) => state.user);

  return user.verified ? children : <Navigate to="/email-verification" state={{
    redirectFrom: '',
  }} />
}
